<template>
  <div class="form__group--border pt-32 pb-8">
    <h2 class="pb-24 heading-2">Share your job preferences</h2>
    <legend class="form__label pb-4">Maximum distance you'll travel for a job</legend>
    <poppins-dropdown
      id="distance-willing-to-travel"
      ref="maxDistance"
      v-model="distanceWillingToTravel"
      labelName="# of miles"
      class="mb-24"
      :options="options"
      :status="formStatuses.distanceWillingToTravel"
      :helperText="helperText(formStatuses.distanceWillingToTravel)"
      @blur="validate"
    />
  </div>
</template>

<script lang="ts">
import helperStatus from '@/helpers/status';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'MaxDistanceSelect',
  components: {
    PoppinsDropdown: Dropdown,
  },
  data(): any {
    return {
      formStatuses: {
        distanceWillingToTravel: helperStatus.Neutral,
      },
      options: [
        {
          value: '1',
          display: '1 mile',
        },
        {
          value: '2',
          display: '2 miles',
        },
        {
          value: '5',
          display: '5 miles',
        },
        {
          value: '10',
          display: '10 miles',
        },
        {
          value: '15',
          display: '15 miles',
        },
        {
          value: '25',
          display: '25 miles',
        },
        {
          value: '40',
          display: '40 miles',
        },
        {
          value: '50',
          display: '50 miles',
        },
      ],
    };
  },
  computed: {
    distanceWillingToTravel: {
      get() {
        return this.$store.getters.getFormField('distanceWillingToTravel');
      },
      set(newValue) {
        this.formStatuses.distanceWillingToTravel = helperStatus.Neutral;
        return this.$store.dispatch('updateForm', { key: 'distanceWillingToTravel', value: newValue });
      },
    },
    fieldIsValid(): boolean {
      return !!this.distanceWillingToTravel;
    },
  },
  methods: {
    validate() {
      if (!this.fieldIsValid) {
        this.formStatuses.distanceWillingToTravel = helperStatus.Error;
      }
      return this.formStatuses.distanceWillingToTravel;
    },
    helperText(status: helperStatus) {
      if (status === helperStatus.Error) {
        return `Select maximum distance you'll travel`;
      }
      return '';
    },
    focusElement(options: FocusOnElementOptions = {}) {
      focusOnElement(this.$refs.maxDistance.$el.querySelector('select'), options);
    },
  },
};
</script>
